var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.875C12 11.16 11.86 11.4075 11.6467 11.535L6.38 14.865C6.27333 14.955 6.14 15 6 15C5.86 15 5.72667 14.955 5.62 14.865L0.353333 11.535C0.14 11.4075 0 11.16 0 10.875V4.125C0 3.84 0.14 3.5925 0.353333 3.465L5.62 0.135C5.72667 0.0450001 5.86 0 6 0C6.14 0 6.27333 0.0450001 6.38 0.135L11.6467 3.465C11.86 3.5925 12 3.84 12 4.125V10.875ZM6 1.6125L4.74 2.415L8.66667 4.9575L9.97333 4.125L6 1.6125ZM2.02667 4.125L6 6.6375L7.30667 5.8125L3.38667 3.2625L2.02667 4.125ZM1.33333 10.4325L5.33333 12.9675V7.935L1.33333 5.4075V10.4325ZM10.6667 10.4325V5.4075L6.66667 7.935V12.9675L10.6667 10.4325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.8274ac3cd26088261ce2eaca58e6528c.svg";
export { ForwardRef as ReactComponent };